import { Link } from "react-router-dom";
import {
  Sparkles,
  ShieldCheck,
  FileText,
  Mail,
  ExternalLink,
} from "lucide-react";
import { Header } from "@/components/homepage/Header";
import { Footer } from "@/components/homepage/Footer";
import { BackButton } from "@/components/BackButton";
import { ABOUT } from "@/constants/testIds";

const InfoRow = ({ icon: Icon, label, value, testId, comingSoon }) => (
  <div
    data-testid={testId}
    className="flex items-center justify-between gap-4 rounded-lg border border-gray-200 bg-white px-4 py-3.5"
  >
    <span className="inline-flex items-center gap-2.5">
      <span className="inline-flex h-8 w-8 items-center justify-center rounded-md bg-gray-900 text-white">
        <Icon className="h-4 w-4" strokeWidth={1.75} />
      </span>
      <span className="text-sm font-medium text-gray-900">{label}</span>
    </span>
    <span className="flex items-center gap-2 text-sm text-gray-600">
      <span>{value}</span>
      {comingSoon && (
        <span className="inline-flex items-center rounded-full border border-gray-200 bg-gray-50 px-2 py-0.5 text-[10px] font-medium uppercase tracking-wider text-gray-500">
          قريباً
        </span>
      )}
    </span>
  </div>
);

export default function AboutPage() {
  return (
    <div className="min-h-screen bg-white text-gray-900">
      <Header />
      <main data-testid={ABOUT.root}>
        <section className="border-b border-gray-200 bg-white">
          <div className="mx-auto max-w-4xl px-6 pt-10 pb-12 lg:px-8 lg:pt-16 lg:pb-16">
            <p className="text-xs font-medium uppercase tracking-wider text-gray-400">
              About Fursalogia
            </p>
            <h1
              data-testid={ABOUT.title}
              className="mt-2 text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl lg:text-5xl"
            >
              حول فرصالوجيا
            </h1>

            <div className="mt-6 max-w-3xl space-y-5 text-base leading-loose text-gray-700">
              <p data-testid={ABOUT.description}>
                فرصالوجيا منصّة رقمية تساعد المستخدمين على اكتشاف واستكشاف الفرص
                الاستثمارية والتجارية والأعمال، من خلال معلومات منظَّمة، ورؤى
                مُهيكلة، ومراجع موثوقة.
              </p>
              <p>
                صُمِّمت المنصّة لتبسيط اكتشاف الفرص ودعم اتخاذ قرارات مدروسة عبر
                تقديم الفرص في صيغة واضحة ومتاحة للجميع.
              </p>
            </div>
          </div>
        </section>

        <section className="mx-auto max-w-4xl px-6 py-12 lg:px-8 lg:py-16">
          <div className="mb-6">
            <p className="text-xs font-medium uppercase tracking-wider text-gray-400">
              معلومات المنصّة
            </p>
            <h2 className="mt-2 text-xl font-semibold tracking-tight text-gray-900">
              تفاصيل الإصدار
            </h2>
          </div>

          <div className="space-y-3">
            <InfoRow
              icon={Sparkles}
              label="الإصدار"
              value="Beta"
              testId={ABOUT.version}
            />
            <InfoRow
              icon={Mail}
              label="تواصل معنا"
              value="قريباً"
              comingSoon
              testId={ABOUT.contact}
            />
            <InfoRow
              icon={ShieldCheck}
              label="سياسة الخصوصية"
              value="قريباً"
              comingSoon
              testId={ABOUT.privacy}
            />
            <InfoRow
              icon={FileText}
              label="شروط الاستخدام"
              value="قريباً"
              comingSoon
              testId={ABOUT.terms}
            />
          </div>

          <div className="mt-10 rounded-2xl border border-gray-200 bg-gray-50 p-6">
            <h3 className="text-sm font-semibold text-gray-900">
              فرصالوجيا في نسخة Beta
            </h3>
            <p className="mt-2 text-sm leading-relaxed text-gray-600">
              نحن نبني فرصالوجيا تدريجياً وباستمرار. بعض الميزات لا تزال قيد التطوير،
              وقد تتغير التجربة مع تطوّر المنتج. شكراً لتجربتك المبكرة.
            </p>
            <Link
              to="/opportunities"
              className="mt-5 inline-flex items-center gap-1.5 text-sm font-medium text-gray-900 hover:text-gray-600"
            >
              استكشف الفرص الآن
              <ExternalLink className="h-3.5 w-3.5" strokeWidth={1.75} />
            </Link>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
